import React from 'react'
import moment from 'moment'
import * as yup from 'yup'
import Avatar from 'components/Avatar'
import PageTitle from 'components/PageTitle'
import AdminLayout from 'components/AdminLayout'
import { FieldAutocomplete, FieldText } from 'components/Fields'
import { useTranslation } from 'react-i18next'
import { Grid, makeStyles } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'
import { useConfirmationDialog } from 'components/Dialog/ConfirmDialog'
import { getTipoUsuariosAdmin } from 'store/modules/tipoUsuarios/tipoUsuarios.selectors'
import { getUsuarioSelecionado, getUsuariosLife } from 'store/modules/usuarios/usuarios.selectors'
import {
  callAtualizarUsuario,
  callCriarUsuario,
  callNovoUsuario,
  callExcluirUsuario,
  callSelecionarUsuario,
} from 'store/modules/usuarios'

const useStyles = makeStyles((theme) => ({
  avatar: {
    display: 'flex',
    alignItems: 'center',
  },
  avatarText: {
    marginLeft: theme.spacing(2),
  },
}))

const UsuarioLife = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const dispatch = useDispatch()
  const dialog = useConfirmationDialog()

  const usuarios = useSelector(getUsuariosLife)
  const usuarioSelecionado = useSelector(getUsuarioSelecionado)
  const tiposUsuario = useSelector(getTipoUsuariosAdmin)

  const tableColumns = [
    { title: t('usuariosAdm.tabelaNome'), key: 'name', width: '40%' },
    { title: t('usuariosAdm.tabelaPermissao'), key: 'permission', width: '29%' },
    { title: t('usuariosAdm.tabelaCadastro'), key: 'date', width: '27%' },
  ]

  const handleSave = (values) => {
    dispatch(usuarioSelecionado ?
      callAtualizarUsuario({ usuario: values, id: usuarioSelecionado.id }) :
      callCriarUsuario(values))
  }

  const handleDelete = ({ id, nome }) => (
    dialog.showConfirmation({
      title: t('dialogs.confirmarExclusao'),
      message: t('dialogs.excluirUsuario', { usuario: nome }),
    }).then((result) => result && dispatch(callExcluirUsuario({ id })))
  )

  const handleEdit = ({ id }) => {
    dispatch(callSelecionarUsuario({ id }))
  }

  const handleCancel = () => {
    dispatch(callNovoUsuario())
  }

  const getTableData = (data) => data.map((item) => ({
    ...item,
    permission: t(item.tipoUsuario?.tipo),
    date: moment(item.createdAt).format('DD/MM/YYYY'),
    name: (
      <div className={classes.avatar}>
        <Avatar initials={item.nome} image={item.avatar} size="small" />
        <span className={classes.avatarText}>{item.nome}</span>
      </div>
    ),
  }))

  return (
    <>
      <PageTitle title={t('menuItemsAdm.configuracoes')} />
      <AdminLayout
        title={t('usuariosAdm.usuariosLife')}
        buttonText={t('usuariosAdm.adicionarUsuario')}
        tableColumns={tableColumns}
        tableData={getTableData(usuarios)}
        onDelete={handleDelete}
        onEdit={handleEdit}
        onCancel={handleCancel}
        renderForm={(Form) => (
          <Form
            onSave={handleSave}
            validate={yup.object({
              nome: yup.string().required(),
              email: yup.string().email().required(),
              tipoUsuarioId: yup.number().required().nullable(),
            })}
            title={t('usuariosAdm.dadosUsuario')}
            initialValues={{
              nome: usuarioSelecionado?.nome ?? '',
              email: usuarioSelecionado?.email ?? '',
              tipoUsuarioId: usuarioSelecionado?.tipoUsuario?.id ?? null,
            }}
          >
            <Grid spacing={4} container>
              <Grid item xs={12}>
                <Grid spacing={2} container>
                  <Grid item xs={6}>
                    <FieldText
                      required
                      name="nome"
                      label={t('inputs.nome')}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FieldText
                      required
                      name="email"
                      label={t('inputs.email')}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FieldAutocomplete
                      required
                      name="tipoUsuarioId"
                      label={t('inputs.permissaoUsuario')}
                      options={tiposUsuario.map((item) => ({
                        value: item.id,
                        label: t(item.tipo),
                      }))}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        )}
      />
    </>
  )
}

export default UsuarioLife
